<div appModal (closeModal)="close()" [closeOnClickOutside]="false" [showCloseButton]="false">
  <section class="modal-title-container">
    <div class="modal--title">Add an athlete to your event</div>
    <p class="modal--subtitle">Add an athlete to this recently purchased event.</p>
    <p class="text-red text-center" *ngIf="errorMessage">{{ errorMessage }}</p>
  </section>

  <section class="modal-content-container" [formGroup]="form">
    <div class="flex mb-20">
      <div class="logo-container">
        <img *ngIf="logo" [src]="logo" class="event-logo" alt="Logo" />
      </div>
      <div class="event-details ml-10">
        <p class="font-bold">{{ purchaseTypeName }}</p>
        <p *ngIf="purchase.event">{{ purchase?.event?.name }}</p>
        <p *ngIf="purchase.event">{{ purchase?.event?.startDate | date: 'MMMM d, yyyy' }}</p>
        <p *ngIf="purchase.event">{{ purchase?.event?.location }}</p>
      </div>
    </div>
    <ng-container *ngIf="!showAddAthlete">
      <div class="item w-full mb-24">
        <ng-select
          [items]="existingAthletes"
          bindLabel="name"
          bindValue="value"
          [clearable]="false"
          (change)="setAthlete($event)"
          [searchable]="false"
          class="mb-18"
          placeholder="Select An Athlete *"
          appendTo="body"
        ></ng-select>
      </div>
      <a href="" class="font-bold" (click)="showNewAthleteForm($event)">+ Add new athlete</a>
    </ng-container>
    <ng-container *ngIf="showAddAthlete">
      <div class="flex mb-20">
        <div class="item w-full">
          <label class="input-title">First name</label>
          <div class="input input-text input-no-min" [class.input-error]="fhs.isInputInvalid(form, 'firstName')">
            <input placeholder="First name" type="text" formControlName="firstName" />
          </div>
        </div>
        <div class="item w-full ml-10">
          <label class="input-title">Last name</label>
          <div class="input input-text input-no-min" [class.input-error]="fhs.isInputInvalid(form, 'lastName')">
            <input placeholder="Last name" type="text" formControlName="lastName" />
          </div>
        </div>
      </div>

      <div class="item w-full mb-20">
        <label class="input-title">Graduation Year</label>
        <div class="input input-text input-no-min" [class.input-error]="fhs.isInputInvalid(form, 'gradYear')">
          <input placeholder="Graduation Year" type="text" formControlName="gradYear" />
        </div>
      </div>

      <div class="item w-full mb-20">
        <label class="input-title">Email</label>
        <div class="input input-text" [class.input-error]="fhs.isInputInvalid(form, 'email')">
          <input placeholder="Email" type="email" formControlName="email" />
        </div>
      </div>
    </ng-container>
  </section>

  <section class="modal-actions-container">
    <button class="btn btn-lg" [class.btn-disabled]="processing" (click)="addClick()">Add Athlete</button>
  </section>
</div>
